import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { validateCampaignTokenAction } from '../../redux/actions/CampaignActions'

export const useCampaign = (token) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { campaignData, isValid, isLoading, errorMessage } = useSelector(
    (state) => state.campaign
  )

  useEffect(() => {
    if (token) {
      dispatch(validateCampaignTokenAction(token))
    }
  }, [token, dispatch])

  useEffect(() => {
    if (token && !isLoading) {
      if (errorMessage || (campaignData && !campaignData.active)) {
        navigate('/', {
          replace: true,
          state: { error: 'El token de campaña es inválido o ha expirado' },
        })
      }
    }
  }, [campaignData, errorMessage, isLoading, token, navigate])

  return { campaignData, isValid, isLoading }
}
